import {FC} from 'react'
import {Link} from 'react-router-dom'
// import {toAbsoluteUrl} from '../../../../_metronic/helpers'

const Error403: FC = () => {
  return (
    <>
      {/* begin::Title */}
      <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>Unauthorized!</h1>
      {/* end::Title */}

      {/* begin::Text */}
      <div className='fw-semibold fs-6 text-gray-500 mb-7'>You do not have access to the requested page.</div>
      {/* end::Text */}

      {/* begin::Illustration */}
      <div className='mb-3'>
        {/* <img
          src={toAbsoluteUrl('/media/auth/403-error.png')}
          className='mw-100 mh-300px theme-light-show'
          alt=''
        />
        <img
          src={toAbsoluteUrl('/media/auth/403-error-dark.png')}
          className='mw-100 mh-300px theme-dark-show'
          alt=''
        /> */}
        <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>
          403!
        </h1>
      </div>
      {/* end::Illustration */}

      {/* begin::Link */}
      <div className='mb-0'>
        <Link to='/' className='btn btn-sm btn-primary'>
          Return Home
        </Link>
      </div>
      {/* end::Link */}
    </>
  )
}

export {Error403}
